import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { ModalBase } from '@softline/ui-core';
import { RequestLog } from '../request-log';
import { RequestLogComponent } from './request-log/request-log.component';
import { RequestLogService } from '../request-log.service';

@Component({
    selector: 'soft-request-log-list',
    imports: [RequestLogComponent],
    templateUrl: './request-log-list.component.html',
    styleUrl: './request-log-list.component.css',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RequestLogListComponent extends ModalBase<any> {
  service = inject(RequestLogService);
  logs = computed<RequestLog[]>(() => this.service.requests())
}
